import { combineReducers, createReducer, on } from '@ngrx/store';
import { omit } from 'lodash';
import * as ConversationActions from '../actions/email-conversation.actions';
import * as EmailMessageActions from '../actions/email-message.actions';
import { WrapUpsSubState } from '../../common/models/wrap-up-sub-state.model';
import { emailConversationEntityAdapter } from '../adapters/email-conversation.adapter';
import { ConversationsSubState, GenesysCloudEmailMessagesSubState, initialConversationsSubState, initialEmailMessagesSubState, initialWrapUpsSubState } from '../genesys-cloud-email-conversations.state';
import { emailMessageEntityAdapter } from '../adapters/email-message.adapter';

const emailConversationsReducer = createReducer(
  initialConversationsSubState(),
  on(ConversationActions.emailConversationsLoaded, (state, { conversations }): ConversationsSubState => emailConversationEntityAdapter.setAll(conversations, state)),
  on(ConversationActions.emailConversationChanged, (state, { conversation }): ConversationsSubState => emailConversationEntityAdapter.setOne(conversation, state)),
  on(ConversationActions.evictEmailConversation, (state, { conversationId }): ConversationsSubState => emailConversationEntityAdapter.removeOne(conversationId, state))
);

const messagesReducer = createReducer(
  initialEmailMessagesSubState(),
  on(EmailMessageActions.emailMessageLoaded, (state, { conversationId, emailMessage }): GenesysCloudEmailMessagesSubState => {
    const existingSubState = state[conversationId] ?? emailMessageEntityAdapter.getInitialState();
    return {
      ...state,
      [conversationId]: emailMessageEntityAdapter.upsertOne(emailMessage, existingSubState)
    };
  }),
  on(ConversationActions.evictEmailConversation, (state, { conversationId }): GenesysCloudEmailMessagesSubState => omit(state, conversationId))
);

const wrapUpsReducer = createReducer(
  initialWrapUpsSubState(),
  on(ConversationActions.wrapUpsLoadedForEmailConversation, (state, { conversationId, wrapUpCodes }): WrapUpsSubState => ({
    ...state,
    [conversationId]: [...wrapUpCodes]
  })),
  on(ConversationActions.evictEmailConversation, (state, { conversationId }): WrapUpsSubState => omit(state, conversationId))
);

export const genesysCloudEmailConversationsReducer = combineReducers({
  conversations: emailConversationsReducer,
  messages: messagesReducer,
  wrapups: wrapUpsReducer
});
